// Country-meta loader. Fetches /api/countries?lang=... once per locale
// and caches the result. The backend is the single source of truth for
// name/networks/flag (see backend/app/data/countries.py); the static
// catalog.ts copy is only used as an offline fallback.

export interface CountryMetaRow {
  code: string
  name: string
  flag: string
  networks: string
}

export type CountryMetaMap = Record<string, CountryMetaRow>

const cache = new Map<string, Promise<CountryMetaMap>>()

export function loadCountryMeta(lang: string): Promise<CountryMetaMap> {
  const key = lang || 'en'
  const hit = cache.get(key)
  if (hit) return hit
  const promise = fetch(`/api/countries?lang=${encodeURIComponent(key)}`, { credentials: 'include' })
    .then((res) => {
      if (!res.ok) throw new Error(`/api/countries ${res.status}`)
      return res.json() as Promise<CountryMetaRow[]>
    })
    .then((rows) => {
      const map: CountryMetaMap = {}
      for (const row of rows) map[row.code] = row
      return map
    })
  cache.set(key, promise)
  // If the fetch fails, drop the cached rejection so a later mount can retry.
  promise.catch(() => cache.delete(key))
  return promise
}

export function clearCountryMetaCache() {
  cache.clear()
}
